import React, { Component } from "react";
import { FaExpandArrowsAlt } from "react-icons/fa";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Tooltip,
} from "@material-ui/core";

import { UploaderPopup } from "./UploaderPopup";
import FileViewer from "./FileViewer";
import {
  getFileExtension,
  isFileTypeImage,
  getImageFilePath,
} from "./FileColumnRenderer";
import ImageLoader from "./ImageLoader";
import { StyledTooltip } from "../../../../../common/utils/StyledTooltip";
import styled, { css } from "styled-components";
import { DIMENSIONS } from "utils/Dimensions";

export default class FileColumnEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.data?.row_id === "+" ? [] : (typeof props.value == "object" ? props.value : (props.value === "+r0w" ? [] : JSON.parse(props.value || "[]"))),
      showModal: false,
      isFileViewerOpen: false,
      isFileViewerGroupOpen: false
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(
      this
    );
  }

  handleChange = (value, shouldAppend = true) => {
    const newValue = shouldAppend ? [...this.state.value, ...value] : value;;
    if(this.props.colDef.store.isLazyLoadEnabled) {
      this.props.colDef.store.isCurrentRowSaving = true;
    }
    this.props.onChange(newValue);

    this.setState({ value: newValue });
    if (!this.state.isFileViewerGroupOpen) {
      this.props.api.stopEditing();
    }
  };

  setShowModal = (showModal) => {
    this.setState({ showModal: showModal });
  };

  componentDidMount() {
    // console.log(this.refs.textArea);
    this.refs.container.addEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    this.focus();
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
  }

  getColIds = () => {
    var nextColId = "",
      prevColId = "",
      columnDefs = this.props?.columnApi?.columnController?.columnDefs;
    for (let i = 0; i < columnDefs.length; i++) {
      if (columnDefs[i]["colId"] === this.props.colDef.colId) {
        nextColId =
          columnDefs[i + 1 === columnDefs.length - 1 ? i : i + 1]["colId"];
        prevColId = columnDefs[i - 1 < 0 ? i : i - 1]["colId"];
        break;
      }
    }
    return { nextColId: nextColId, prevColId: prevColId };
  };

  arrowKeyNavigation = (event) => {
    // console.log("file");
    if ([13].indexOf(event.keyCode) > -1) {
      event.stopPropagation();
      let editPermissionData = this.hasEditPermissions();
      if(Number(this.props.node?.data?.row_id) && !editPermissionData[0]) {
        const message = editPermissionData[1];
        window.appStore.notificationStore.showNotification(
          message,
          "caution"
        );
      } else if(this.props.colDef?.cellRendererParams?.columnOptions?.is_read_only) {
        window.appStore.notificationStore.showNotification(
          "This is a non-editable cell",
          "caution"
        );
        return;
      } else {
        this.setState({ showModal: true });
      }
    } else {
      var { nextColId, prevColId } = this.getColIds();
      if ([37].indexOf(event.keyCode) > -1) {
        event.preventDefault();
        this.focusNextCell(this.props.rowIndex, prevColId);
      }
      if ([38].indexOf(event.keyCode) > -1) {
          event.preventDefault();
          this.focusNextCell(
          this.props.rowIndex === 0 ? 0 : this.props.rowIndex - 1,
          this.props.column.colId
        );
      }
      if ([39].indexOf(event.keyCode) > -1) {
        event.preventDefault();
        this.focusNextCell(this.props.rowIndex, nextColId);
      }
      if ([40].indexOf(event.keyCode) > -1) {
        event.preventDefault();
        this.focusNextCell(this.props.rowIndex + 1, this.props.column.colId);
      }
    }
  };
  focusNextCell = (
    rowIndex = this.props.rowIndex + 1,
    colId = this.props.column.colId
  ) => {
    this.props.api.clearRangeSelection();
    this.props.api.stopEditing();
    this.props.colDef.store.addRowOnGrid(
      rowIndex,
      this.props.node.id,
      this.props.context,
      colId
    );
    this.props.api.setFocusedCell(rowIndex, colId);
  };

  focus() {
    window.setTimeout(() => {
      if(this.refs.input) {
        this.refs.input.focus();
      }
    });
  }

  getValue() {
    return this.state.value;
  }

  handleOpenFileViewer = (index) => this.setState({ isFileViewerOpen: true, fileViewerStartIndex: index })
  handleCloseFileViewer = () => this.setState({ isFileViewerOpen: false })

  displayImages(value) {
    const images = [];
    const files = [];
    const columnOptions = this.props.colDef.cellRendererParams.columnOptions;
    const rowHeight = this.props.node.rowHeight - 5;

    value.forEach((file, index) => {
      const ext = getFileExtension(file);

      if (isFileTypeImage(ext)) {
        images.push(
          <StyledTooltip title={file.name}>
            <ImageLoader
              src={getImageFilePath(file, rowHeight)}
              mode="fit"
              style={{
                width: rowHeight,
                height: rowHeight - 5,
              }}
              key={file.fullpath}
              onClick={() => this.handleOpenFileViewer(index)}
              className="image_thumbnail"
            />
          </StyledTooltip>
        );
        return;
      }

      files.push(
        <StyledTooltip title={file.name}>
          <span onClick={() => this.handleOpenFileViewer(index)} className={"file_thumbnail fiv-sqo fiv-icon-blank fiv-icon-" + ext} style={{ width: rowHeight - 5, height: rowHeight - 5, fontSize: rowHeight + "rem" }}></span>
        </StyledTooltip>
      );
    });

    return <React.Fragment>{[...images, ...files]}</React.Fragment>;
  }

  handleAddFiles = () => {
    if (this.state.isFileViewerGroupOpen) {
      this.setState({ isFileViewerGroupOpen: false }, e => setTimeout(e => this.setState({ showModal: true }), 300))
    } else {
      this.setState({ showModal: true });
    }
  }

  hasEditPermissions = () => {
    let editPermissionData;
    if (this.props.colDef?.store?.isSubsheet && this.props.colDef?.store?.parentListId) {
      const parentListContainerStore = window.appStore.getCurrentListContainerStore(this.props.colDef.store.parentListId);
      editPermissionData = parentListContainerStore?.permissions?.canEdit(this.props.colDef.store.parentColumnId, this.props.colDef.store.parentRow);
    } else {
      editPermissionData = window.appStore?.containerStore?.permissions.canEdit(
        this.props.colDef?.cellRendererParams?.columnId,
        this.props.node?.data
      );
    }
    return editPermissionData;
  }

  render() {
    const value = this.state.value;
    const rowHeight = this.props.node.rowHeight - 5;
    const rootStyle = {
      display: "grid",
      alignContent: "flex-end",
      width: Number(this.props.colDef.width),
      maxHeight: rowHeight - 3,
    };
    const items = (
      <React.Fragment>
        <span
          className="add-new"
          onClick={()=> {
            let editPermissionData = this.hasEditPermissions();
            if (this.props.colDef?.cellRendererParams?.columnOptions?.is_read_only) {
              window.appStore.notificationStore.showNotification(
                "This is a non-editable cell",
                "caution"
              );
              return;
            }
            if(Number(this.props.node?.data?.row_id) && !editPermissionData[0]) {
              const message = editPermissionData[1];
              window.appStore.notificationStore.showNotification(
                message,
                "caution"
              );
            } else {
              this.handleAddFiles();
            }
          }}
          style={{
            height: rowHeight - 5
          }}
        >
          +
        </span>
        {this.displayImages(value)}
        <UploaderPopup
          onChange={this.handleChange}
          showModal={this.state.showModal}
          setShowModal={this.setShowModal}
          max_files={this.props.colDef.cellRendererParams?.columnOptions?.max_files}
          allowed_file_types={this.props.colDef.cellRendererParams?.columnOptions?.allowed_file_types}
          columnId={this.props.colDef.cellRendererParams?.columnId}
          fileCount={value.length}
        />
      </React.Fragment>
    )

    return (
      <FileEditorDiv
        ref="container"
        width={Number(this.props.colDef.width)}
        maxHeight={rowHeight - 3}
        rowHeight={this.props.node.rowHeight}
      >
        {(this.props.data?.row_id != "+" && this.props.value != "+r0w") && (
        <>
          <input
            ref="input"
            type="checkbox"
            className="custom-control-input"
            id="defaultChecked"
            onChange={() => { }}
            checked={false}
          />
          <div style={{ overflow: 'hidden', maxWidth: "83%", display: "flex", alignItems: "center", maxHeight: rootStyle.maxHeight }}>
            {items}
          </div>
          <div
            className="expandArrow"
            style={{ position: "absolute", right: 5, top: 5 }}
            onClick={() => {
              this.setState({ isFileViewerGroupOpen: true });
            }}
          >
            <FaExpandArrowsAlt size={14} />
          </div>
        </>
        )}
        {
          this.state.isFileViewerOpen && <FileViewer
            files={value}
            open={this.state.isFileViewerOpen}
            startIndex={this.state.fileViewerStartIndex}
            onClose={this.handleCloseFileViewer}
            onChange={(val) => this.handleChange(val, false)}
            hasEditPermissions={this.hasEditPermissions}
            nodeData={this.props.node.data}
            isSubsheet={this.props.colDef?.store?.isSubsheet}
            isReadOnly={this.props.colDef?.cellRendererParams?.columnOptions?.is_read_only}
          />
        }

        <Dialog
          open={this.state.isFileViewerGroupOpen}
          onClose={() => {
            this.setState({ isFileViewerGroupOpen: false });
          }}
          PaperProps={{ style: { minWidth: 300 } }}
        >
          <DialogContent style={{ overflow: 'hidden' }}>
            {items}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ isFileViewerGroupOpen: false });
                this.props.api.stopEditing();
              }}
              color="primary"
            >
              Close
              </Button>
          </DialogActions>
        </Dialog>
      </FileEditorDiv>
    );
  }
}

const FileEditorDiv = styled.div`
  display: grid;
  align-content: flex-end;
  width: ${({ width }) => width + "px"};
  max-height: ${({ maxHeight }) => maxHeight + "px"};
  line-height: ${({ rowHeight }) =>
    rowHeight <= DIMENSIONS.cell_height_compact ? "normal" : ""};
`;